import React, { useState } from "react";
import Styles from "./styles.module.scss";
import Logo from "../_UI/logo";
import LangSwitcher from "../langSwitcher";
import avatar from "../../theme/assets/other/lp_cabinet_avatar.png";
import {walletShorter} from "../../helpers/walletShorter";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useDisconnect} from "wagmi";
import {useTranslation} from "react-i18next";
import {disconnectUser} from "../../store/cabinet/action";

const AuthHeader = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { disconnect } = useDisconnect();
    const { t } = useTranslation();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const userData = useSelector((store) => store.cabinet.userData);

    const [absSettingStatus, setAbsSettingStatus] = useState(false);
    const [absNavStatus, setAbsNavStatus] = useState(false);

    // ✅ состояние дропдауна языка живет тут, чтобы выключать settings и наоборот
    const [langOpen, setLangOpen] = useState(false);

    const handleLogout = () => {
        dispatch(disconnectUser());
        disconnect();
    };

    const toggleSettings = () => {
        setAbsSettingStatus((prev) => {
            const next = !prev;
            if (next) setLangOpen(false); // ✅ открыли settings -> закрыли язык
            return next;
        });
    };

    const toggleLang = () => {
        setLangOpen((prev) => {
            const next = !prev;
            if (next) setAbsSettingStatus(false); // ✅ открыли язык -> закрыли settings
            return next;
        });
    };

    const closeAllPopups = () => {
        setAbsSettingStatus(false);
        setLangOpen(false);
    };

    return (
        <section className={`${Styles.container}`}>
            {/* MOBILE */}
            <div
                className={`${Styles.contentWrap} ${Styles.pageContainer} ${Styles.contentWrapM}`}
            >
                <Logo />
                <div
                    className={`${Styles.navBtn}`}
                    onClick={() => {
                        setAbsNavStatus(true);
                        closeAllPopups();
                    }}
                >
                    <div />
                    <div />
                    <div />
                </div>

                <div
                    className={`${Styles.absNavWrap} ${
                        absNavStatus ? Styles.absNavWrapActive : null
                    }`}
                >
                    <div className={`${Styles.absNavWrapPos}`}>
                        <div
                            className={`${Styles.absNavCloseBtn}`}
                            onClick={() => {
                                setAbsNavStatus(false);
                                closeAllPopups();
                            }}
                        >
                            <div />
                            <div />
                        </div>

                        <div className={`${Styles.absNavBox}`}>
                            <div className={`${Styles.navWrap}`}>
                                <div
                                    className={`${Styles.navItem}`}
                                    onClick={() => {
                                        navigate("/launchpad");
                                        setAbsNavStatus(false);
                                        closeAllPopups();
                                    }}
                                >
                                    {t('Главная')}
                                </div>

                                <div
                                    className={`${Styles.navItem}`}
                                    onClick={() => {
                                        navigate("/projects");
                                        setAbsNavStatus(false);
                                        closeAllPopups();
                                    }}
                                >
                                    {t("Все проекты")}
                                </div>

                                <div
                                    className={`${Styles.navItem}`}
                                    onClick={() => {
                                        navigate("/about");
                                        setAbsNavStatus(false);
                                        closeAllPopups();
                                    }}
                                >
                                    {t("О нас")}
                                </div>

                                <div
                                    className={`${Styles.navItem}`}
                                    onClick={() => {
                                        navigate("/apply-for-ido");
                                        setAbsNavStatus(false);
                                        closeAllPopups();
                                    }}
                                >
                                    {t("Заявка на IDO")}
                                </div>

                                <div
                                    className={`${Styles.navItem}`}
                                    onClick={() => {
                                        navigate("/omt-academy");
                                        setAbsNavStatus(false);
                                        closeAllPopups();
                                    }}
                                >
                                    OMT {t("Академия")}
                                </div>
                            </div>

                            <div className={`${Styles.otherWrap}`}>
                                <LangSwitcher
                                    isVertical={true}
                                    isOpen={langOpen}
                                    onToggle={toggleLang}
                                    onClose={() => setLangOpen(false)}
                                />

                                {
                                    authStatus ?
                                        <>
                                            <div
                                                className={`${Styles.userWrap}`}
                                                onClick={toggleSettings}
                                            >
                                                <img
                                                    src={userData?.user?.avatar_url || avatar}
                                                    alt="avatar"
                                                />
                                            </div>

                                            <div
                                                className={`${Styles.absSettingsWrap} ${
                                                    absSettingStatus ? Styles.absSettingsWrapActive : ""
                                                }`}
                                            >
                                                <div className={`${Styles.absSettingsMain}`}>
                                                    <div className={`${Styles.avatarWrap}`}>
                                                        <img src={avatar} alt="avatar" />
                                                    </div>
                                                    <div className={`${Styles.infoWrap}`}>
                                                        <div className={`${Styles.infoWrapWallet}`}>
                                                            {walletShorter(userData?.user?.wallet)}
                                                        </div>
                                                        <div className={`${Styles.infoWrapName}`}>
                                                            {userData?.user?.name}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={`${Styles.absSettingsNav}`}>
                                                    <div
                                                        className={`${Styles.absSettingsNavItem}`}
                                                        onClick={() => {
                                                            setAbsSettingStatus(false);
                                                            navigate("/profile");
                                                        }}
                                                    >
                                                        {t("Профиль")}
                                                    </div>

                                                    <div
                                                        className={`${Styles.absSettingsNavItem}`}
                                                        onClick={() => {
                                                            setAbsSettingStatus(false);
                                                            handleLogout();
                                                        }}
                                                    >
                                                        {t("Выйти")}
                                                    </div>
                                                </div>
                                            </div>
                                        </> :
                                        <div className={`${Styles.btn}`}
                                             onClick={() => {
                                                 setAbsSettingStatus(false);
                                                 setAbsNavStatus(false);
                                                 navigate("/sign-up");
                                             }}
                                        >
                                            {t('Войти')}
                                        </div>
                                }
                            </div>
                            {/* otherWrap */}
                        </div>
                        {/* absNavBox */}
                    </div>
                    {/* absNavWrapPos */}
                </div>
                {/* absNavWrap */}
            </div>

            {/* DESKTOP */}
            <div
                className={`${Styles.contentWrap} ${Styles.pageContainer} ${Styles.contentWrapD}`}
            >
                <Logo />

                <div className={`${Styles.navWrap}`}>
                    <div
                        className={`${Styles.navItem}`}
                        onClick={() => {
                            navigate("/launchpad");
                            closeAllPopups();
                        }}
                    >
                        {t('Главная')}
                    </div>

                    <div
                        className={`${Styles.navItem}`}
                        onClick={() => {
                            navigate("/projects");
                            closeAllPopups();
                        }}
                    >
                        {t("Все проекты")}
                    </div>

                    <div
                        className={`${Styles.navItem}`}
                        onClick={() => {
                            navigate("/about");
                            closeAllPopups();
                        }}
                    >
                        {t("О нас")}
                    </div>

                    <div
                        className={`${Styles.navItem}`}
                        onClick={() => {
                            navigate("/apply-for-ido");
                            closeAllPopups();
                        }}
                    >
                        {t("Заявка на IDO")}
                    </div>

                    <div
                        className={`${Styles.navItem}`}
                        onClick={() => {
                            navigate("/omt-academy");
                            closeAllPopups();
                        }}
                    >
                        OMT {t("Академия")}
                    </div>
                </div>

                <div className={`${Styles.posWrap}`}>
                    <LangSwitcher
                        isVertical={true}
                        isOpen={langOpen}
                        onToggle={toggleLang}
                        onClose={() => setLangOpen(false)}
                    />

                    {
                        authStatus ?
                            <>
                                <div className={`${Styles.userWrap}`} onClick={toggleSettings}>
                                    <img src={userData?.user?.avatar_url || avatar} alt="avatar" />
                                </div>

                                <div
                                    className={`${Styles.absSettingsWrap} ${
                                        absSettingStatus ? Styles.absSettingsWrapActive : ""
                                    }`}
                                >
                                    <div className={`${Styles.absSettingsMain}`}>
                                        <div className={`${Styles.avatarWrap}`}>
                                            <img src={avatar} alt="avatar" />
                                        </div>
                                        <div className={`${Styles.infoWrap}`}>
                                            <div className={`${Styles.infoWrapWallet}`}>
                                                {walletShorter(userData?.user?.wallet)}
                                            </div>
                                            <div className={`${Styles.infoWrapName}`}>
                                                {userData?.user?.name}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`${Styles.absSettingsNav}`}>
                                        <div
                                            className={`${Styles.absSettingsNavItem}`}
                                            onClick={() => {
                                                setAbsSettingStatus(false);
                                                navigate("/profile");
                                            }}
                                        >
                                            {t("Профиль")}
                                        </div>

                                        <div
                                            className={`${Styles.absSettingsNavItem}`}
                                            onClick={() => {
                                                setAbsSettingStatus(false);
                                                handleLogout();
                                            }}
                                        >
                                            {t("Выйти")}
                                        </div>
                                    </div>
                                </div>
                            </> :
                            <div className={`${Styles.btn}`}
                                 onClick={() => {
                                     setAbsSettingStatus(false);
                                     navigate("/sign-up");
                                 }}
                            >
                                {t('Войти')}
                            </div>
                    }
                </div>
                {/* posWrap */}
            </div>
        </section>
    );
};

export default AuthHeader;